export default __webpack_public_path__ + "static/media/mialn.5ff17f3e.jpg";